import { computed } from "@ember/object";
import { classNames } from "@ember-decorators/component";
import { topicLevels } from "discourse/lib/notification-levels";
import NotificationsButtonComponent from "select-kit/components/notifications-button";
import { pluginApiIdentifiers, selectKitOptions } from "select-kit/components/select-kit";
const TopicNotificationsOptions = dt7948.c(class TopicNotificationsOptions extends NotificationsButtonComponent {
  content = topicLevels;
  get i18nPostfix() {
    return this.topic.archetype === "private_message" ? "_pm" : "";
  }
  static {
    dt7948.n(this.prototype, "i18nPostfix", [computed("topic.archetype")]);
  }
}, [pluginApiIdentifiers("topic-notifications-options"), selectKitOptions({
  i18nPrefix: "topic.notifications",
  i18nPostfix: "i18nPostfix",
  showCaret: true
}), classNames("topic-notifications-options")]);
export default TopicNotificationsOptions;